import React from 'react';
import { CopyableId } from '../../modals/blocks';
import Pill from '../Pill';
import { OWNED_BADGE_LABEL } from '../constants';

const CarrierCell = ({ row }) => {
    const { business_name, owned, carrier } = row.original;
    if (!carrier) {
        return <span className="text-[13px] font-semibold text-slate-900">{business_name}</span>;
    }

    const alias = carrier.alias;
    const dot = carrier.dot_number;

    return (
        <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-2">
                <span className="text-[13px] font-semibold text-slate-900">{business_name}</span>
                {owned ? <Pill tone="owned">{OWNED_BADGE_LABEL}</Pill> : null}
            </div>
            {alias ? (
                <span className="text-[11px] text-muted">
                    Alias: <span className="text-info">{alias}</span>
                </span>
            ) : null}
            <span className="text-[11px] text-muted">
                DOT {dot || '—'}
                {carrier.business_city ? ` · ${carrier.business_city}` : ''}
            </span>
            <div className="mt-0.5 flex min-w-0 [&_button]:max-w-full [&_button>span]:truncate">
                <CopyableId label="Account ID" value={row.original.client_id} />
            </div>
        </div>
    );
};

export default CarrierCell;
